import AFRAME from "aframe";

AFRAME.registerSystem('animations', {
    _camelcase: function (v) {
        return v.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        });
    },
    show: function (element, effect) {
        const me = this;
        const method = this._camelcase('show-' + effect);

        if (typeof me[method] === "function") {
            me[method](element);
        } else {
            element.setAttribute('advanced-visible', true);
        }
    },
    hide: function (element, effect) {
        const me = this;
        const method = this._camelcase('hide-' + effect);

        if (typeof me[method] === "function") {
            me[method](element);
        } else {
            element.setAttribute('advanced-visible', false);
        }
    },
    showSwirl: function (element) {
        element.object3D.scale.x = 0;
        element.object3D.scale.y = 0;
        element.object3D.rotation.z = Math.PI * 2;
        element.setAttribute('advanced-visible', true);

        AFRAME.ANIME({
            targets: element.object3D.scale,
            x: {
                value: 1,
                duration: 500,
                easing: 'easeOutQuad',
            },
            y: {
                value: 1,
                duration: 500,
                easing: 'easeOutQuad',
            },
            round: 1000,
            complete: function (anim) {
            }
        });

        AFRAME.ANIME({
            targets: element.object3D.rotation,
            z: {
                value: 0,
                duration: 500,
                easing: 'easeOutQuad',
            },
            round: 1000,
            complete: function (anim) {
            }
        });
    },
    hideSwirl: function (element) {

        AFRAME.ANIME({
            targets: element.object3D.scale,
            x: {
                value: 0,
                duration: 500,
                easing: 'easeInQuad',
            },
            y: {
                value: 0,
                duration: 500,
                easing: 'easeInQuad',
            },
            round: 1000,
            complete: function (anim) {
            }
        });

        AFRAME.ANIME({
            targets: element.object3D.rotation,
            z: {
                value: -Math.PI * 2,
                duration: 500,
                easing: 'easeInQuad',
            },
            round: 1000,
            complete: function (anim) {
                element.setAttribute('advanced-visible', false);
                element.object3D.scale.x = 1;
                element.object3D.scale.y = 1;
                element.object3D.rotation.z = 0;
            }
        });
    },
    showRotate: function (element) {
        element.object3D.rotation.z = Math.PI * 2;
        element.setAttribute('advanced-visible', true);

        AFRAME.ANIME({
            targets: element.object3D.rotation,
            z: {
                value: 0,
                duration: 500,
                easing: 'easeOutQuad',
            },
            round: 1000,
            complete: function (anim) {
            }
        });
    },
    hideRotate: function (element) {
        AFRAME.ANIME({
            targets: element.object3D.rotation,
            z: {
                value: -Math.PI * 2,
                duration: 500,
                easing: 'easeInQuad',
            },
            round: 1000,
            complete: function (anim) {
                element.setAttribute('advanced-visible', false);
                element.object3D.rotation.z = 0;
            }
        });
    },
    showScale: function (element) {
        element.setAttribute('advanced-visible', true);
        element.object3D.scale.x = 0;
        element.object3D.scale.y = 0;

        AFRAME.ANIME({
            targets: element.object3D.scale,
            x: {
                value: 1,
                duration: 300,
                easing: 'easeInOutExpo',
            },
            y: {
                value: 1,
                duration: 300,
                easing: 'easeInOutExpo',
            },
            round: 1000,
            complete: function (anim) {
            }
        });
    },
    hideScale: function (element) {
        AFRAME.ANIME({
            targets: element.object3D.scale,
            x: {
                value: 0,
                duration: 300,
                easing: 'easeInOutExpo',
            },
            y: {
                value: 0,
                duration: 300,
                easing: 'easeInOutExpo',
            },
            round: 1000,
            complete: function (anim) {
                element.setAttribute('advanced-visible', false);
            }
        });
    },
    showTv: function (element) {
        element.setAttribute('advanced-visible', true);
        element.object3D.scale.x = 0;
        element.object3D.scale.y = 0.05;
        element.object3D.scale.z = 1;

        AFRAME.ANIME.timeline().add({
            targets: element.object3D.scale,
            x: {
                value: 1,
                duration: 300,
                easing: 'easeInOutExpo',
            },
            round: 1000,
        }).add({
            targets: element.object3D.scale,
            y: {
                value: 1,
                duration: 300,
                easing: 'easeInOutExpo',
            },
            round: 1000,
            complete: function (anim) {
            }
        });
    },
    hideTv: function (element) {
        AFRAME.ANIME.timeline().add({
            targets: element.object3D.scale,
            y: {
                value: 0.05,
                duration: 300,
                easing: 'easeInOutExpo',
            },
            round: 1000,
        }).add({
            targets: element.object3D.scale,
            x: {
                value: 0,
                duration: 300,
                easing: 'easeInOutExpo',
            },
            round: 1000,
            complete: function (anim) {
                // me.el.components.material.material.opacity = 1;
                element.object3D.scale.x = 1;
                element.object3D.scale.y = 1;
                element.setAttribute('advanced-visible', false);
            }
        });
    },
    scaleUp: function (element, scale) {
        AFRAME.ANIME({
            targets: element.object3D.scale,
            x: {
                value: scale,
                duration: 300,
                easing: 'easeOutQuad',
            },
            y: {
                value: scale,
                duration: 300,
                easing: 'easeOutQuad',
            },
            round: 1000,
            complete: function (anim) {
            }
        });
    },
    scaleDown: function (element) {
        AFRAME.ANIME({
            targets: element.object3D.scale,
            x: {
                value: 1,
                duration: 300,
                easing: 'easeOutQuad',
            },
            y: {
                value: 1,
                duration: 300,
                easing: 'easeOutQuad',
            },
            round: 1000,
            complete: function (anim) {
            }
        });
    },
    lightUp: function (element) {
        AFRAME.ANIME({
            targets: element.components.material.material,
            opacity: {
                value: 1,
                duration: 300,
                easing: 'easeOutQuad',
            },
            round: 1000,
            complete: function (anim) {
            }
        });
    },
    lightDown: function (element) {
        AFRAME.ANIME({
            targets: element.components.material.material,
            opacity: {
                value: 0.75,
                duration: 300,
                easing: 'easeOutQuad',
            },
            round: 1000,
            complete: function (anim) {
            }
        });
    },
    moveUp: function (element) {
        AFRAME.ANIME({
            targets: element.object3D.position,
            z: {
                value: 0.005,
                duration: 300,
                easing: 'easeOutQuad',
            },
            round: 1000,
            complete: function (anim) {
            }
        });
    },
    moveDown: function (element) {
        AFRAME.ANIME({
            targets: element.object3D.position,
            z: {
                value: 0,
                duration: 300,
                easing: 'easeOutQuad',
            },
            round: 1000,
            complete: function (anim) {
            }
        });
    },
});

AFRAME.registerComponent('ui-icon', {
    dependencies: ['material'],
    init: function () {
        const me = this;

        me.el.setAttribute('material', {opacity: 0.75});
        const animations = document.querySelector('a-scene').systems['animations'];
        me.el.addEventListener('mouseenter', () => {
            animations.scaleUp(me.el,1.2);
            animations.lightUp(me.el);
            animations.moveUp(me.el);
        });
        me.el.addEventListener('mouseleave', () => {
            animations.scaleDown(me.el);
            animations.lightDown(me.el);
            animations.moveDown(me.el);
        });
    }
});

AFRAME.registerComponent('hover-effect-scale', {
    dependencies: ['material'],
    schema: {
        scale: {type:'number',default: 2}
    },
    init: function () {
        const me = this;
        const animations = document.querySelector('a-scene').systems['animations'];

        me.el.addEventListener('mouseenter', () => {
            const visible = me.el.components.visible ? me.el.components.visible.data : true;
            if (visible) {
                animations.scaleUp(me.el,me.data.scale);
            }
        });
        me.el.addEventListener('mouseleave', () => {
            const visible = me.el.components.visible ? me.el.components.visible.data : true;
            if (visible) {
                animations.scaleDown(me.el);
            }
        });

    }
});